import type { trpc } from '@web-app/utils/trpc';

type TrpcUtils = ReturnType<typeof trpc.useUtils>;

/** Bridge case and embedded Photon notes share eligibility; refresh both together. */
export async function invalidateMedicareBridgePrescribingContext(
  utils: TrpcUtils,
  patientHealthieId: string,
): Promise<void> {
  await Promise.all([
    utils.medicareBridge.getCase.invalidate({ patientHealthieId }),
    utils.prescriptionReviewV2.photonPrescriberNote.invalidate({
      patientHealthieId,
    }),
  ]);
}
